// Copyright 2016 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { Router, RouterConfiguration } from "aurelia-router";
import { RouteConfigCatalog } from "catalogs/RouteConfigCatalog";
import { IAuthentication } from "libraries/Authentication/IAuthentication";
import { OpenIDAuthenticationStep } from "libraries/Authentication/OpenIDAuthenticationStep";
import { ServiceWorkerHandler } from "libraries/ServiceWorker/ServiceWorkerHandler";
import { ClientRequiredStep } from "services/Client/ClientRequiredStep";
import { LicenseCheckStep } from "services/License/LicenseCheckStep";
import { ModuleRestoreStep } from "services/Module/ModuleRestoreStep";
import { WorkflowModeStep } from "services/WorkflowModes/WorkflowModeStep";

@autoinject
export class RouterManager {
    private readonly serviceWorkerHandler: ServiceWorkerHandler;
    private readonly authentication: IAuthentication;

    constructor(serviceWorkerHandler: ServiceWorkerHandler, authentication: IAuthentication) {
        this.serviceWorkerHandler = serviceWorkerHandler;
        this.authentication = authentication;
    }

    public configureRouter(config: RouterConfiguration, router: Router) {
        this.serviceWorkerHandler.registerWorker();

        config.title = "Sorama Sound Imaging Portal";
        config.addPipelineStep("authorize", OpenIDAuthenticationStep);
        config.addPipelineStep("authorize", ClientRequiredStep);
        config.addPipelineStep("authorize", LicenseCheckStep);
        config.addPipelineStep("preActivate", WorkflowModeStep);
        config.addPipelineStep("preActivate", ModuleRestoreStep);
        config.map(RouteConfigCatalog.routes);
        config.mapUnknownRoutes(RouteConfigCatalog.catchAllRoute);
        config.options.pushState = true;
        config.options.hashChange = false;

        // Leave this last as the main portal routes need to be configured first
        return this.authentication.configure(config);
    }
}
